import { styledSystemProps } from './dom-helpers';

/**
 * styled-components에서 DOM으로 전달할 속성을 필터링하는 함수
 * 기본적으로 styledSystemProps 목록에 있는 속성을 제외하고,
 * 필요한 경우 추가 제외 속성을 지정할 수 있습니다.
 *
 * @example
 * const Button = styled.button.withConfig({
 *   shouldForwardProp: shouldForwardProp(['customProp1', 'customProp2'])
 * })`...`;
 *
 * @param additionalProps 추가로 제외할 props 목록
 * @returns shouldForwardProp 함수 구현
 */
export const shouldForwardProp = (additionalProps: string[] = []) => {
  const allExcludedProps = [...styledSystemProps, ...additionalProps];

  return (prop: string): boolean => {
    return !allExcludedProps.includes(prop);
  };
};

/**
 * styled-components에서 transient props($로 시작하는 속성)를 만드는 헬퍼
 *
 * @example
 * const CustomComponent = styled.div`
 *   ${props => props.$isActive && 'background-color: blue;'}
 * `;
 *
 * <CustomComponent $isActive={true} />
 *
 * @param props 객체
 * @param propName 변환할 속성 이름
 * @returns $로 시작하는 transient prop
 */
export const transientProp = <T extends Record<string, unknown>, K extends keyof T>(
  props: T,
  propName: K,
): boolean => {
  const transientKey = `$${String(propName)}` as keyof T;
  return Boolean(props[transientKey]);
};
